{
  "GENERAL": {
    "CLOSE": "إغلاق",
    "SHOWING_RESULTS": "عرض{firstIndex}-{lastIndex} من {totalCount} إجمالي العناصر",
    "PHONE_INPUT": {
      "PLACEHOLDER": "بحث",
      "EMPTY_STATE": "لم يتم العثور على النتائج"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "يلزم {count} على الأقل"
  }
}
